/** @hidden */
export function attributeValueContainsToken(attributeName: string, token: string) {
  return `[${attributeName}~="${token}"]`
}
